import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-licence',
    templateUrl: './licence.component.html',
    styleUrls: ['./licence.component.scss']
})
export class LicenceComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }
}
